<div>
  <item-list *ngIf="items.length > 0" 
      [items]="items" 
      [enableButtons]="true" 
      [showPurchasePrice]="false"
      [showPrice]="!hasGMailIntegration"
      (onDelete)="deleteItem($event)" 
      [orderBy]="['dateOfPurchase', 'state']"/>
      
  <div class="spinner" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>